/**
 * FH Price Range Slider
 * 
 * Custom element for a dual-handle price range slider.
 * Only shown when NO price filter is active (user must clear first).
 * 
 * @version 9.0.0 - Simplified (only shown when no filter active)
 */

(function() {
  'use strict';

  /**
   * Parse price value
   */
  function parsePrice(value) {
    if (value === null || value === undefined || value === '') return 0;
    var str = String(value).trim();
    var lastDot = str.lastIndexOf('.');
    var lastComma = str.lastIndexOf(',');
    if (lastComma > lastDot) {
      str = str.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      str = str.replace(/,/g, '');
    }
    var num = parseFloat(str);
    return isNaN(num) ? 0 : num;
  }

  /**
   * Format for European locale
   */
  function formatEU(val) {
    return val.toFixed(2).replace('.', ',');
  }

  /**
   * Initialize a slider
   */
  function initSlider(el) {
    if (el.querySelector('.fh-slider')) return;

    var min = parsePrice(el.dataset.min);
    var max = parsePrice(el.dataset.max);
    var curMin = parsePrice(el.dataset.currentMin) || min;
    var curMax = parsePrice(el.dataset.currentMax) || max;

    if (max <= 0 || max <= min) return;

    el.innerHTML = 
      '<div class="fh-slider">' +
        '<div class="fh-slider__track">' +
          '<div class="fh-slider__track-active"></div>' +
        '</div>' +
        '<div class="fh-slider__inputs">' +
          '<input type="range" class="fh-slider-min" min="' + min + '" max="' + max + '" value="' + curMin + '" step="0.01">' +
          '<input type="range" class="fh-slider-max" min="' + min + '" max="' + max + '" value="' + curMax + '" step="0.01">' +
        '</div>' +
      '</div>';

    var sMin = el.querySelector('.fh-slider-min');
    var sMax = el.querySelector('.fh-slider-max');
    var track = el.querySelector('.fh-slider__track-active');

    if (!sMin || !sMax || !track) return;

    // Find Shopify inputs
    var container = el.closest('price-facet-component') || el.closest('.price-facet') || el.parentElement;
    var shopifyMin = container ? (container.querySelector('[ref="minInput"]') || container.querySelector('input[name*="filter.v.price.gte"]')) : null;
    var shopifyMax = container ? (container.querySelector('[ref="maxInput"]') || container.querySelector('input[name*="filter.v.price.lte"]')) : null;
    var priceFacet = el.closest('price-facet-component');

    var state = { min: min, max: max, curMin: curMin, curMax: curMax };

    function updateTrack() {
      var range = state.max - state.min;
      if (range <= 0) return;
      var left = ((state.curMin - state.min) / range) * 100;
      var width = ((state.curMax - state.min) / range) * 100 - left;
      track.style.left = Math.max(0, left) + '%';
      track.style.width = Math.max(0, width) + '%';
    }

    function triggerUpdate() {
      if (shopifyMin) shopifyMin.value = formatEU(state.curMin);
      if (shopifyMax) shopifyMax.value = formatEU(state.curMax);
      
      if (priceFacet && typeof priceFacet.updatePriceFilterAndResults === 'function') {
        priceFacet.updatePriceFilterAndResults();
      }
    }

    sMin.addEventListener('input', function() {
      var minV = parseFloat(sMin.value);
      var maxV = parseFloat(sMax.value);
      if (minV >= maxV - 0.5) {
        minV = maxV - 0.5;
        sMin.value = minV;
      }
      state.curMin = minV;
      updateTrack();
      if (shopifyMin) shopifyMin.value = formatEU(minV);
    });

    sMax.addEventListener('input', function() {
      var minV = parseFloat(sMin.value);
      var maxV = parseFloat(sMax.value);
      if (maxV <= minV + 0.5) {
        maxV = minV + 0.5;
        sMax.value = maxV;
      }
      state.curMax = maxV;
      updateTrack();
      if (shopifyMax) shopifyMax.value = formatEU(maxV);
    });

    sMin.addEventListener('change', triggerUpdate);
    sMax.addEventListener('change', triggerUpdate);

    updateTrack();
  }

  function initAll() {
    document.querySelectorAll('fh-price-range-slider').forEach(initSlider);
  }

  // Custom element
  if (!customElements.get('fh-price-range-slider')) {
    customElements.define('fh-price-range-slider', class extends HTMLElement {
      connectedCallback() {
        setTimeout(() => initSlider(this), 20);
      }
    });
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => setTimeout(initAll, 50));

  // MutationObserver for AJAX
  new MutationObserver(function(mutations) {
    for (var m of mutations) {
      for (var n of m.addedNodes) {
        if (n.nodeType === 1 && (n.tagName === 'FH-PRICE-RANGE-SLIDER' || (n.querySelector && n.querySelector('fh-price-range-slider')))) {
          setTimeout(initAll, 50);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();
